import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '@components/layout/Layout';
import { Home } from '@pages/Home';
import { SessionSetupPage } from '@pages/SessionSetup';
import { ActiveObservationPage } from '@pages/ActiveObservation';
import { SessionReviewPage } from '@pages/SessionReview';
import { SettingsPage } from '@pages/Settings';
import { ActiveSessionsPage } from '@pages/ActiveSessions';
import { PrintSummariesPage } from '@pages/PrintSummaries';
import { NotFound } from '@pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'sessions',
        element: <ActiveSessionsPage />,
      },
      {
        path: 'session/new',
        element: <SessionSetupPage />,
      },
      {
        path: 'session/:sessionId/observe',
        element: <ActiveObservationPage />,
      },
      {
        path: 'session/:sessionId/review',
        element: <SessionReviewPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/print-summaries',
    element: <PrintSummariesPage />,
  },
]);
